var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
        'cag-button',
        {
            outlined: _vm.outlined,
            error: _vm.error,
            success: _vm.success,
            'no-border': _vm.noBorder,
        },
    ],attrs:{"disabled":_vm.disabled,"type":_vm.type}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }